export default "__VITE_ASSET__3eWLfXT6__"